export default {
  path: '/cost-centers',
  component: () => import(/* webpackChunkName: "cost-centers" */ './CostCenters'),
  meta: {
    requiresAuth: true
  }
}
